import type { IconData } from '@stacksjs/iconify-core'

export const coffeeBeanSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.305 2.286C30.285 1.236 35.42 2.124 39.662 6l.027.025c-3.617.81-6.872 2.344-9.612 4.698c-3.516 3.021-6.086 7.309-7.53 12.903c-1.317 5.109-3.606 8.823-6.578 11.377c-2.765 2.376-6.207 3.821-10.21 4.392c-3.671-4.19-4.502-9.214-3.473-14.089c1.041-4.93 3.976-9.725 7.781-13.561a283 283 0 0 1 1.677-1.677c3.836-3.805 8.63-6.74 13.561-7.78\"/><path fill=\"currentColor\" d=\"m8.31 41.976l.028.025c4.243 3.875 9.378 4.764 14.357 3.713c4.931-1.04 9.725-3.975 13.561-7.78a295 295 0 0 0 1.677-1.678c3.806-3.836 6.74-8.63 7.781-13.56c1.03-4.876.199-9.9-3.473-14.09c-4.003.571-7.444 2.016-10.21 4.392c-2.972 2.554-5.26 6.268-6.578 11.377c-1.444 5.594-4.013 9.882-7.53 12.903c-2.74 2.354-5.994 3.888-9.612 4.698\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default coffeeBeanSolid
